export const getCountryCode = (country: string) => {
  if (country.slice(0, 2).toLowerCase() === "ru") {
    return "ru-RU"
  } else if (country.slice(0, 2).toLowerCase() === "en") {
    return "en-EN"
  } else if (country.slice(0, 2).toLowerCase() === "fr") {
    return "fr-FR"
  }
  return "ru-RU"
}